import * as yup from 'yup';
import { useTranslation } from 'react-i18next';

export const useTransactionPaymentValidation = () => {
    const { t } = useTranslation();
    return yup.object({
        fullName: yup.string().max(50).required(t('RequiredField')).nullable(),
        email: yup.string().email(t('InvalidEmail')).nullable(),
        // paidAmount: yup.number().required(t('RequiredField')).typeError(t('InvalidNumber')).nullable(),
        paidAt: yup
            .date()
            .min(new Date('1/1/2000'), `${t('BeforeCurrentDate')} ${new Date('1/1/2000').toISOString().split('T')[0]} `)
            .required(t('RequiredField'))
            .typeError(t('InvalidDate'))
            .nullable()
    });
};
